
class SelectorLayer {
    name: string;
    definition: 'selector';
    selector: string;
}

class ListLayer {
    name: string;
    definition: 'list';
    objectIds: string[];
}

type Layer = ListLayer | SelectorLayer;


// definition for a single layer set
export class LayersModel {
    description: string;
    layers: Layer[];
}

// collection of layers sets available in the scene
export class LayerSetsModel {
    [key: string]: LayersModel;
}
